import { __spreadArray } from '../../node_modules/tslib/tslib.es6.js';

var chartColors = __spreadArray([], Array(6), true).map(function (e, i) {
    return __spreadArray([], Array(i + 1), true).map(function (e, j) { return "var(--recharts-color-".concat(i + 1, "-").concat(j + 1, ")"); });
});
var getChartColors = function (dataCount) {
    var index = Math.min(dataCount, chartColors.length) - 1;
    return chartColors[index];
};
// for pie and radial bar
var chartColorsAlternate = [
    [1],
    [1, 2],
    [1, 2, 3],
    [1, 4, 2, 3],
    [1, 5, 2, 4, 3],
    [1, 6, 2, 5, 3, 4],
].map(function (a, i) { return a.map(function (b) { return "var(--recharts-color-".concat(i + 1, "-").concat(b, ")"); }); });
var getChartColorsAlternate = function (dataCount) {
    var index = Math.min(dataCount, chartColorsAlternate.length) - 1;
    return chartColorsAlternate[index];
};

export { chartColors, chartColorsAlternate, getChartColors, getChartColorsAlternate };
